import styled from "styled-components";

export const Title = styled.div`
  margin-bottom: 16px;
  h3 {
    font-size: 24px;
    font-weight: 600;
  }
`;
